module.exports = __webpack_public_path__ + "img/背景.c49444b7.png";